// extracted by mini-css-extract-plugin
export var noSpinners = "_o1-6";
export var percentageInput = "_o1-7";
export var variantColor1 = "_o1-0";
export var variantColor2 = "_o1-1";
export var variantColor3 = "_o1-2";
export var variantColor4 = "_o1-3";
export var variantColor5 = "_o1-4";
export var variantColor6 = "_o1-5";